import { Outlet, RouteObject } from 'react-router'
import { ObjectsWithConfig } from '../objects/objects'
import { Root } from './root'
import { Detail, Relation, RelationEdit } from './widgets'

export const CLIENTS_ROUTES: RouteObject = {
	path: 'client/*',
	element: <Root />,
	children: [
		{
			path: '',
			index: true,
			element: <ObjectsWithConfig object="client" name="main" />,
		},
		{
			path: ':id',
			element: <Outlet />,
			children: [
				{
					index: true,
					element: <Detail />,
				},
				{
					path: ':object',
					element: <Outlet />,
					children: [
						{
							index: true,
							element: <Relation />,
						},
						{
							path: ':id',
							element: <RelationEdit />,
						},
					],
				},
			],
		},
	],
}
